import Rails from '@rails/ujs';

export default class BackofficeExtendedEligibilityZonesIndex {

  constructor() {
    this.map = null;
    this.polygons = [];
    this.zones = [];
    this.previewMap = null;
    this.previewPolygon = null;

    this.mapEl = document.getElementById('zones-map');
    if (!this.mapEl) return;

    this.urls = {
      zonesJson: this.mapEl.dataset.zonesUrl,
      create: this.mapEl.dataset.createUrl,
      update: this.mapEl.dataset.updateUrl,
      destroy: this.mapEl.dataset.destroyUrl,
      import: this.mapEl.dataset.importUrl,
      bulkEntities: this.mapEl.dataset.bulkEntitiesUrl
    };

    this.initMap();
    this.loadZones();
    this.bindEvents();
  }

  initMap() {
    this.map = new google.maps.Map(this.mapEl, {
      center: { lat: 46.603354, lng: 1.888334 },
      zoom: 6,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      streetViewControl: false,
      styles: [
        { featureType: "poi", stylers: [{ visibility: "off" }] },
        { featureType: "transit", elementType: "labels.icon", stylers: [{ visibility: "off" }] }
      ]
    });
  }

  bindEvents() {
    // Create zone
    const previewBtn = document.getElementById('preview-zone-btn');
    if (previewBtn) previewBtn.addEventListener('click', () => this.previewZone());

    const createBtn = document.getElementById('confirm-create-zone-btn');
    if (createBtn) createBtn.addEventListener('click', () => this.createZone());

    // Edit zone - delegated
    document.addEventListener('click', (e) => {
      const zoomBtn = e.target.closest('.zoom-zone-btn');
      if (zoomBtn) {
        e.preventDefault();
        this.zoomToZone(Number.parseInt(zoomBtn.dataset.zoneId, 10));
      }

      const editBtn = e.target.closest('.edit-zone-btn');
      if (editBtn) {
        e.preventDefault();
        this.openEditModal(Number.parseInt(editBtn.dataset.zoneId, 10));
      }

      const deleteBtn = e.target.closest('.delete-zone-btn');
      if (deleteBtn) {
        e.preventDefault();
        this.deleteZone(Number.parseInt(deleteBtn.dataset.zoneId, 10));
      }
    });

    const editConfirmBtn = document.getElementById('confirm-edit-zone-btn');
    if (editConfirmBtn) editConfirmBtn.addEventListener('click', () => this.updateZone());

    // Entity config
    const entitySelectAll = document.getElementById('entity-select-all');
    if (entitySelectAll) {
      entitySelectAll.addEventListener('change', (e) => {
        document.querySelectorAll('.entity-ext-checkbox').forEach(cb => { cb.checked = e.target.checked; });
      });
    }

    const entityConfigBtn = document.getElementById('confirm-entity-config-btn');
    if (entityConfigBtn) entityConfigBtn.addEventListener('click', () => this.saveEntityConfig());

    // Import
    const importBtn = document.getElementById('confirm-import-btn');
    if (importBtn) importBtn.addEventListener('click', () => this.importZones());

    // Reset create modal on hide
    const createModal = document.getElementById('createZoneModal');
    if (createModal) {
      $(createModal).on('hidden.bs.modal', () => this.resetCreateModal());
    }

    // Reset import modal on hide
    const importModal = document.getElementById('importZonesModal');
    if (importModal) {
      $(importModal).on('hidden.bs.modal', () => this.resetImportModal());
    }
  }

  loadZones() {
    Rails.ajax({
      url: this.urls.zonesJson,
      type: 'GET',
      dataType: 'json',
      success: (data) => {
        this.zones = data;
        this.renderPolygonsOnMap();
      }
    });
  }

  renderPolygonsOnMap() {
    // Clear existing polygons
    this.polygons.forEach(p => p.setMap(null));
    this.polygons = [];

    const bounds = new google.maps.LatLngBounds();
    const colorMap = {
      'immediat': '#28a745',
      'q1_2026': '#17a2b8',
      'q2_2026': '#ffc107',
      'q3_2026': '#fd7e14',
      'q4_2026': '#dc3545',
      'not_commercialisable': '#6c757d'
    };

    this.zones.forEach(zone => {
      const coords = zone.parsed_coordinates;
      if (!coords || coords.length < 3) return;

      const paths = coords.map(c => ({ lat: c[0], lng: c[1] }));
      const fillColor = colorMap[zone.commercialisation_date] || '#007bff';

      const polygon = new google.maps.Polygon({
        paths: paths,
        strokeColor: fillColor,
        strokeOpacity: 0.9,
        strokeWeight: 2,
        fillColor: fillColor,
        fillOpacity: 0.3,
        map: this.map
      });

      polygon.zoneId = zone.id;

      polygon.addListener('click', () => {
        this.openEditModal(zone.id);
      });

      paths.forEach(p => bounds.extend(p));
      this.polygons.push(polygon);
    });

    if (this.zones.length > 0 && !bounds.isEmpty()) {
      this.map.fitBounds(bounds);
    }
  }

  // --- Create Zone ---

  previewZone() {
    const coordsRaw = document.getElementById('create-zone-coordinates').value;
    const parsed = this.parseCoordinates(coordsRaw);

    if (parsed.length < 3) {
      this.showCreateError('Les coordonnées doivent contenir au moins 3 points.');
      return;
    }

    this.hideCreateError();
    const previewContainer = document.getElementById('create-zone-preview-map');
    previewContainer.style.display = 'block';

    if (!this.previewMap) {
      this.previewMap = new google.maps.Map(previewContainer, {
        center: { lat: parsed[0][0], lng: parsed[0][1] },
        zoom: 12,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false
      });
    }

    if (this.previewPolygon) {
      this.previewPolygon.setMap(null);
    }

    const paths = parsed.map(c => ({ lat: c[0], lng: c[1] }));
    this.previewPolygon = new google.maps.Polygon({
      paths: paths,
      strokeColor: '#007bff',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#007bff',
      fillOpacity: 0.3,
      map: this.previewMap
    });

    const bounds = new google.maps.LatLngBounds();
    paths.forEach(p => bounds.extend(p));
    this.previewMap.fitBounds(bounds);
  }

  createZone() {
    const coordsRaw = document.getElementById('create-zone-coordinates').value;
    const name = document.getElementById('create-zone-name').value;
    const commercialisation = document.getElementById('create-zone-commercialisation').value;
    const agglo = document.getElementById('create-zone-agglo').value;
    const priority = document.getElementById('create-zone-priority').value;

    const parsed = this.parseCoordinates(coordsRaw);
    if (parsed.length < 3) {
      this.showCreateError('Les coordonnées doivent contenir au moins 3 points.');
      return;
    }

    const formData = new FormData();
    formData.append('zone[name]', name);
    formData.append('zone[coordinates_json]', coordsRaw.trim());
    formData.append('zone[commercialisation_date]', commercialisation);
    formData.append('zone[agglo_securisee]', agglo);
    formData.append('zone[priority]', priority);

    Rails.ajax({
      url: this.urls.create,
      type: 'POST',
      data: formData,
      dataType: 'json',
      success: (data) => {
        if (data.success) {
          $('#createZoneModal').modal('hide');
          window.application.successNotification('Zone créée avec succès.');
          this.loadZones();
          this.refreshPage();
        } else {
          this.showCreateError((data.errors || []).join(', '));
        }
      },
      error: (response) => {
        const data = JSON.parse(response.response);
        this.showCreateError((data.errors || ['Erreur lors de la création.']).join(', '));
      }
    });
  }

  // --- Edit Zone ---

  openEditModal(zoneId) {
    const zone = this.zones.find(z => z.id === zoneId);
    if (!zone) return;

    document.getElementById('edit-zone-id').value = zone.id;
    document.getElementById('edit-zone-name').value = zone.name || '';
    document.getElementById('edit-zone-coordinates').value = zone.coordinates_json;
    document.getElementById('edit-zone-commercialisation').value = zone.commercialisation_date;
    document.getElementById('edit-zone-agglo').value = zone.agglo_securisee;
    document.getElementById('edit-zone-priority').value = zone.priority;

    this.hideEditError();
    $('#editZoneModal').modal('show');
  }

  updateZone() {
    const zoneId = document.getElementById('edit-zone-id').value;
    const name = document.getElementById('edit-zone-name').value;
    const commercialisation = document.getElementById('edit-zone-commercialisation').value;
    const agglo = document.getElementById('edit-zone-agglo').value;
    const priority = document.getElementById('edit-zone-priority').value;

    const url = this.urls.update.replace('__ID__', zoneId);

    const formData = new FormData();
    formData.append('zone[name]', name);
    formData.append('zone[commercialisation_date]', commercialisation);
    formData.append('zone[agglo_securisee]', agglo);
    formData.append('zone[priority]', priority);

    Rails.ajax({
      url: url,
      type: 'PATCH',
      data: formData,
      dataType: 'json',
      success: (data) => {
        if (data.success) {
          $('#editZoneModal').modal('hide');
          window.application.successNotification('Zone mise à jour.');
          this.loadZones();
          this.refreshPage();
        } else {
          this.showEditError((data.errors || []).join(', '));
        }
      },
      error: (response) => {
        const data = JSON.parse(response.response);
        this.showEditError((data.errors || ['Erreur lors de la mise à jour.']).join(', '));
      }
    });
  }

  // --- Delete Zone ---

  deleteZone(zoneId) {
    const url = this.urls.destroy.replace('__ID__', zoneId);

    Rails.ajax({
      url: url,
      type: 'DELETE',
      dataType: 'json',
      success: () => {
        window.application.successNotification('Zone supprimée.');
        this.loadZones();
        this.refreshPage();
      },
      error: () => {
        window.application.errorNotification('Erreur lors de la suppression.');
      }
    });
  }

  zoomToZone(zoneId) {
    if (!this.map) return;

    const zone = this.zones.find(z => z.id === zoneId);
    if (!zone || !zone.parsed_coordinates || zone.parsed_coordinates.length < 3) {
      window.application.errorNotification('Impossible de zoomer sur cette zone.');
      return;
    }

    const bounds = new google.maps.LatLngBounds();
    zone.parsed_coordinates.forEach((coord) => {
      bounds.extend({ lat: coord[0], lng: coord[1] });
    });

    this.map.fitBounds(bounds);

    const polygon = this.polygons.find((poly) => poly.zoneId === zoneId);
    if (polygon) {
      polygon.setOptions({ strokeWeight: 4, fillOpacity: 0.45 });
      window.setTimeout(() => {
        polygon.setOptions({ strokeWeight: 2, fillOpacity: 0.3 });
      }, 1200);
    }
  }

  // --- Entity Configuration ---

  saveEntityConfig() {
    const checkboxes = document.querySelectorAll('.entity-ext-checkbox:checked');
    const entityIds = Array.from(checkboxes).map(cb => cb.value);

    const formData = new FormData();
    entityIds.forEach(id => formData.append('entity_ids[]', id));

    Rails.ajax({
      url: this.urls.bulkEntities,
      type: 'POST',
      data: formData,
      dataType: 'json',
      success: (data) => {
        if (data.success) {
          $('#entityConfigModal').modal('hide');
          window.application.successNotification('Configuration des entités enregistrée.');
        }
      },
      error: () => {
        window.application.errorNotification('Erreur lors de la sauvegarde.');
      }
    });
  }

  // --- Import ---

  importZones() {
    const fileInput = document.getElementById('import-file');
    const file = fileInput.files[0];

    if (!file) {
      window.application.errorNotification('Veuillez sélectionner un fichier.');
      return;
    }

    document.getElementById('import-processing').style.display = 'block';
    document.getElementById('import-success').style.display = 'none';
    document.getElementById('import-errors').style.display = 'none';

    const formData = new FormData();
    formData.append('file', file);

    Rails.ajax({
      url: this.urls.import,
      type: 'POST',
      data: formData,
      dataType: 'json',
      success: (data) => {
        document.getElementById('import-processing').style.display = 'none';
        if (data.success) {
          document.getElementById('import-success').style.display = 'block';
          document.getElementById('import-success-message').textContent =
            `${data.imported_count} zone(s) importée(s) avec succès.`;
          this.loadZones();
          this.refreshPage();
        } else {
          this.showImportErrors(data.errors || ['Erreur inconnue.']);
        }
      },
      error: (response) => {
        document.getElementById('import-processing').style.display = 'none';
        const data = JSON.parse(response.response);
        this.showImportErrors(data.errors || ['Erreur lors de l\'import.']);
      }
    });
  }

  // --- Helpers ---

  parseCoordinates(raw) {
    if (!raw || !raw.trim()) return [];

    return raw.split(';').reduce((acc, pair) => {
      const cleaned = pair.trim().replaceAll(/[()]/g, '');
      if (!cleaned) return acc;

      const parts = cleaned.split(',').map(s => s.trim());
      if (parts.length !== 2) return acc;

      const lat = Number.parseFloat(parts[0]);
      const lng = Number.parseFloat(parts[1]);
      if (Number.isNaN(lat) || Number.isNaN(lng)) return acc;

      acc.push([lat, lng]);
      return acc;
    }, []);
  }

  showCreateError(msg) {
    const el = document.getElementById('create-zone-errors');
    el.textContent = msg;
    el.style.display = 'block';
  }

  hideCreateError() {
    document.getElementById('create-zone-errors').style.display = 'none';
  }

  showEditError(msg) {
    const el = document.getElementById('edit-zone-errors');
    el.textContent = msg;
    el.style.display = 'block';
  }

  hideEditError() {
    document.getElementById('edit-zone-errors').style.display = 'none';
  }

  showImportErrors(errors) {
    const list = document.getElementById('import-errors-list');
    list.innerHTML = '';
    errors.forEach(err => {
      const li = document.createElement('li');
      li.textContent = err;
      list.appendChild(li);
    });
    document.getElementById('import-errors').style.display = 'block';
  }

  resetCreateModal() {
    document.getElementById('create-zone-name').value = '';
    document.getElementById('create-zone-coordinates').value = '';
    document.getElementById('create-zone-commercialisation').value = 'immediat';
    document.getElementById('create-zone-agglo').value = 'agglo_oui';
    document.getElementById('create-zone-priority').value = '0';
    document.getElementById('create-zone-preview-map').style.display = 'none';
    this.hideCreateError();
    if (this.previewPolygon) {
      this.previewPolygon.setMap(null);
      this.previewPolygon = null;
    }
  }

  resetImportModal() {
    document.getElementById('import-file').value = '';
    document.getElementById('import-processing').style.display = 'none';
    document.getElementById('import-success').style.display = 'none';
    document.getElementById('import-errors').style.display = 'none';
  }

  refreshPage() {
    window.location.reload();
  }

  onDestroy() {
    this.polygons.forEach(p => p.setMap(null));
    this.polygons = [];
  }
}
